<template>
    <div v-show="visible">
        <el-dialog title="导入" :visible.sync="visible" :close-on-click-modal="false"
            v-loading="loading"
            :before-close="dialogClose" width="420px">
            <el-form ref="form" label-width="80px">
                <el-form-item label="学校">
                    <el-select v-model="form.deptId" placeholder="请选择学校" disabled>
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <div class="import-step">
                    <div class="import-step__left">
                        <div class="import-step__title">1. 下载模版</div>
                        <div class="import-step__desc">请严格按照数据模版的格式准备导入数据</div>
                    </div>
                    <div class="import-step__right">
                        <el-button type="primary" plain icon="el-icon-download" @click="downLoad">下载模版</el-button>
                    </div>
                </div>

                <div class="import-step">
                    <div class="import-step__left">
                        <div class="import-step__title">2. 选择要导入文件</div>
                        <div class="import-step__desc">点击“上传文件”选择要上传的文件</div>
                    </div>
                    <div class="import-step__right">
                    </div>
                </div>
                <div class="import-step">
                    <el-upload
                        class="upload-demo"
                        :action="uploadUrl"
                        :show-file-list="false"
                        :auto-upload="true"
                        :before-upload="beforeUpload">
                        <el-button type="primary" plain icon="el-icon-upload2">上传文件</el-button>
                    </el-upload>
                    <div class="import-file" v-if="fileName">
                        {{fileName}}
                    </div>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible:false,
                loading:false,
                uploadUrl:"",
                depts:[],
                file:null,
                fileName:"",
                form:{
                    deptId:""
                }
            }
        },
        methods:{
            init(deptId){
                this.visible = true;
                this.loading = false;
                this.file = null;
                this.fileName = "";
                this.form.deptId = deptId || "";
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.uploadUrl = this.cardImportUrl;
                this.getDepts();
            },
            dialogClose(done){
                done();
                this.$parent.importVisible = false;
            },
            downLoad(){
                var fileSaver = require('file-saver');
                fileSaver.saveAs("../../../../static/card.xlsx","卡号导入模板.xlsx");
            },
            beforeUpload(file){
                let fileType = file.type;
                let isLt100M = file.size / 1024 / 1024 < 100;
                if(this.$constant.excelFileType.indexOf(fileType) == -1){
                    this.$commonFn.showTip('导入文件只支持.xls与.xlsx', 3);
                    return false;
                }
                if (!isLt100M) {
                    this.$commonFn.showTip('文件大小不能超过100MB!', 3);
                    return false;
                }
                this.file = file;
                this.fileName = file.name || "";
                this.submitImport();

                // 阻止 el-upload 继续走 action 默认上传
                return false;
            },
            submitImport(){
                if(!this.form.deptId){
                    this.$commonFn.showTip("请选择学校",2);
                    return;
                }
                if(!this.file){
                    this.$commonFn.showTip("请选择要导入的文件",2);
                    return;
                }
                // 复用 ImportUser.vue 的上传方式
                this.loading=true;
                let uploadForm=new FormData();
                uploadForm.append('file', this.file);
                uploadForm.append('deptId', this.form.deptId);
                this.$axios.post(this.cardImportUrl, uploadForm).then((res) => {
                    if(res.data.status == 200){
                        this.$commonFn.showTip(res.data.message, 4,true);
                        this.visible=false;
                        this.$parent.importVisible = false;
                        this.$parent.common.page = 1;
                        this.$parent.getData();
                    }else{
                        this.$commonFn.showTip(res.data.message, 3);
                    }
                    this.loading=false;
                }, (err) => {
                    console.log(err);
                    this.loading=false;
                    this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3);
                });
            },
            getDepts(){
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
.import-step{
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding:18px 0;
}
.import-step + .import-step{
    border-top:1px solid #f0f0f0;
}
.import-step__left{
    flex:1;
    padding-right:12px;
}
.import-step__right{
    width:150px;
    text-align:right;
}
.import-step__title{
    font-size:16px;
    color:#303133;
    line-height:22px;
}
.import-step__desc{
    font-size:12px;
    color:#909399;
    line-height:18px;
    margin-top:6px;
}
.import-footer{
    text-align:center;
    margin-top:18px;
}
.import-file{
    font-size:12px;
    color:#909399;
    margin-top:8px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
}
</style>




// WEBPACK FOOTER //
// src/components/page/sys/card/Import.vue